import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  button: {
    marginHorizontal: 16,
    marginVertical: 32,
  },
  inputStyle: {
    marginHorizontal: 20,
    marginTop: 15.6,
  },
  label: {
    fontFamily: Fonts.type.VFFont,
    paddingTop: 1,
  },
  disabledBUttonStyle: theme => ({
    backgroundColor: theme.colors.buttons.disabled,
  }),
  disabledTextStyle: theme => ({
    color: theme.colors.textButtons.disabled,
  }),
});
